import type { Glider } from "../lib/glider";

/** Provenance / meta for the selected glider, shown under the picker. */
export function GliderInfo({ glider }: { readonly glider: Glider }) {
  return (
    <div className="mb-5 rounded-md border border-border bg-panel-2 px-3 py-2.5 text-xs leading-relaxed text-muted">
      <span className="text-ink">{glider.wingArea_m2} m²</span> wing area · ref.
      mass <span className="text-ink">{glider.referenceMass_kg} kg</span>
      {glider.notes !== undefined && (
        <>
          <br />
          {glider.notes}
        </>
      )}
    </div>
  );
}
